import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { telLink, waLink } from "@/lib/api";
import { NAV } from "./Header";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./icons";

export const Footer = ({ s, nav = NAV }) => (
  <footer id="contato" data-testid="site-footer" className="relative bg-[#050507] border-t border-white/10 grain">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 pt-24 lg:pt-32 pb-12">
      <Reveal className="max-w-3xl">
        <p className="label-caps mb-5">{s.contact_label}</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]" data-testid="contact-title">{s.contact_title}</h2>
        <p className="mt-6 text-sm sm:text-base text-[#A1A1AA] leading-relaxed max-w-xl">{s.contact_text}</p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 pr-16 sm:pr-0">
          <a href={waLink(s.whatsapp_number, s.wa_msg_reservations)} target="_blank" rel="noopener noreferrer" className="btn-lux btn-gold" data-testid="contact-whatsapp-button">
            <WhatsAppIcon className="w-4 h-4" /> {s.btn_whatsapp}
          </a>
          <a href={telLink(s.phone_number)} className="btn-lux" data-testid="contact-call-button">
            <Phone className="w-4 h-4" strokeWidth={1.5} /> {s.btn_call}
          </a>
        </div>
      </Reveal>

      <div className="mt-24 pt-16 border-t border-white/10 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src="/logo.png" alt="Gran Hotel Sé" className="h-14 w-auto" loading="lazy" width="168" height="56" data-testid="footer-logo" />
          <p className="mt-6 text-sm text-[#71717A] leading-relaxed max-w-sm">{s.footer_text}</p>
        </div>
        <div className="md:col-span-4 space-y-4 text-sm text-[#D4D4D8]">
          <p className="label-caps !text-[#CBD5E1]/70">Endereço & contato</p>
          <p data-testid="footer-address">{s.address_line}<br />{s.address_city} · {s.address_cep}</p>
          <a href={waLink(s.whatsapp_number, s.wa_msg_default)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-white transition-colors" data-testid="footer-whatsapp-link">
            <WhatsAppIcon className="w-4 h-4 text-[#CBD5E1]" /> {s.whatsapp_display}
          </a>
          <a href={telLink(s.phone_number)} className="flex items-center gap-3 hover:text-white transition-colors" data-testid="footer-phone-link">
            <Phone className="w-4 h-4 text-[#CBD5E1]" strokeWidth={1.5} /> {s.phone_display}
          </a>
          {s.email && (
            <a href={`mailto:${s.email}`} className="flex items-center gap-3 hover:text-white transition-colors" data-testid="footer-email-link">
              <Mail className="w-4 h-4 text-[#CBD5E1]" strokeWidth={1.5} /> {s.email}
            </a>
          )}
        </div>
        <nav className="md:col-span-3 grid grid-cols-2 md:grid-cols-1 gap-3 text-sm" aria-label="Rodapé">
          <p className="label-caps !text-[#CBD5E1]/70 col-span-2 md:col-span-1">Navegação</p>
          {nav.map((n) => (
            <a key={n.href} href={n.href} className="text-[#A1A1AA] hover:text-white transition-colors py-1" data-testid={`footer-nav-${n.href.slice(1)}`}>{n.label}</a>
          ))}
        </nav>
      </div>

      <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row gap-4 justify-between text-xs text-[#71717A] pb-20 sm:pb-0">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} {s.hotel_name}. Todos os direitos reservados.</p>
        <Link to="/privacidade" className="hover:text-white transition-colors" data-testid="footer-privacy-link">Política de privacidade</Link>
      </div>
    </div>
  </footer>
);
